export default "__VITE_ASSET__GEmgrD3G__"